import { apiFetch } from "../auth/apiClient";

export const carpoolsApi = {
  list: ({ q, day } = {}) => {
    const p = new URLSearchParams();
    if (q) p.set("q", q);
    if (day) p.set("day", day);
    const qs = p.toString();
    return apiFetch(`/api/carpools${qs ? `?${qs}` : ""}`, {
      method: "GET",
      authRequired: true,
    });
  },
  myOffered: () =>
    apiFetch("/api/carpools/me/offered", { method: "GET", authRequired: true }),
  myJoined: () =>
    apiFetch("/api/carpools/me/joined", { method: "GET", authRequired: true }),
  get: (id) =>
    apiFetch(`/api/carpools/${id}`, { method: "GET", authRequired: true }),
  create: (body) =>
    apiFetch("/api/carpools", { method: "POST", authRequired: true, body }),
  patch: (id, body) =>
    apiFetch(`/api/carpools/${id}`, { method: "PATCH", authRequired: true, body }),
  cancel: (id) =>
    apiFetch(`/api/carpools/${id}`, { method: "DELETE", authRequired: true }),
  requestToJoin: (rideId, body) =>
    apiFetch(`/api/carpools/${rideId}/requests`, {
      method: "POST",
      authRequired: true,
      body,
    }),
  patchRequest: (reqId, action) =>
    apiFetch(`/api/carpools/requests/${reqId}`, {
      method: "PATCH",
      authRequired: true,
      body: { action },
    }),
};

export const DAY_LABELS = {
  MON: "Mon",
  TUE: "Tue",
  WED: "Wed",
  THU: "Thu",
  FRI: "Fri",
  SAT: "Sat",
  SUN: "Sun",
};

export const ALL_DAYS = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"];

export const carsApi = {
  list: () => apiFetch("/api/cars", { method: "GET", authRequired: true }),
  add: (body) => apiFetch("/api/cars", { method: "POST", authRequired: true, body }),
  remove: (id) => apiFetch(`/api/cars/${id}`, { method: "DELETE", authRequired: true }),
};

export function carLabel(car) {
  return `${car.color} ${car.make} ${car.model_name} · ${car.plate_number}`;
}
